package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PlayingCardsW500Rounded: ImageVector
    get() {
        if (_playingCardsW500Rounded != null) {
            return _playingCardsW500Rounded!!
        }
        _playingCardsW500Rounded = Builder(name = "PlayingCardsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(617.63f, 565.0f)
                lineToRelative(30.28f, -109.13f)
                quadToRelative(4.24f, -13.91f, -0.74f, -27.59f)
                quadToRelative(-4.97f, -13.67f, -17.41f, -22.39f)
                lineToRelative(-92.61f, -63.32f)
                quadToRelative(-9.43f, -6.72f, -20.13f, -2.86f)
                quadToRelative(-10.69f, 3.86f, -14.17f, 15.29f)
                lineToRelative(-30.28f, 109.13f)
                quadToRelative(-4.24f, 13.91f, 0.73f, 27.59f)
                quadToRelative(4.98f, 13.67f, 17.42f, 22.39f)
                lineToRelative(92.61f, 63.32f)
                quadToRelative(9.43f, 6.72f, 20.13f, 2.86f)
                quadToRelative(10.69f, -3.86f, 14.17f, -15.29f)
                close()
                moveTo(151.87f, 755.63f)
                lineToRelative(-33.24f, -15.52f)
                quadToRelative(-31.0f, -13.0f, -41.88f, -44.58f)
                quadToRelative(-10.88f, -31.58f, 3.12f, -62.66f)
                lineToRelative(72.0f, -156.0f)
                verticalLineToRelative(278.76f)
                close()
                moveTo(311.99f, 842.87f)
                quadToRelative(-33.12f, 0.0f, -56.62f, -23.93f)
                reflectiveQuadToRelative(-23.5f, -56.83f)
                verticalLineToRelative(-239.24f)
                lineToRelative(106.77f, 294.0f)
                quadToRelative(2.99f, 7.0f, 5.23f, 13.5f)
                reflectiveQuadToRelative(7.24f, 12.5f)
                horizontalLineToRelative(-39.12f)
                close()
                moveTo(530.78f, 841.93f)
                quadToRelative(-35.54f, 12.68f, -70.25f, -3.11f)
                quadToRelative(-34.7f, -15.8f, -47.38f, -51.34f)
                lineToRelative(-175.8f, -484.46f)
                quadToRelative(-12.68f, -35.54f, 3.24f, -69.87f)
                quadToRelative(15.91f, -34.32f, 51.45f, -47.0f)
                lineToRelative(296.22f, -108.32f)
                quadToRelative(35.54f, -12.68f, 69.87f, 3.24f)
                quadToRelative(34.33f, 15.91f, 47.0f, 51.45f)
                lineToRelative(176.33f, 484.22f)
                quadToRelative(12.67f, 35.54f, -3.12f, 69.87f)
                quadToRelative(-15.8f, 34.32f, -51.34f, 47.0f)
                lineTo(530.78f, 841.93f)
                close()
                moveTo(499.2f, 756.41f)
                lineTo(795.7f, 648.09f)
                lineTo(618.85f, 163.59f)
                lineTo(323.11f, 271.91f)
                lineTo(499.2f, 756.41f)
                close()
                moveTo(559.52f, 460.0f)
                close()
            }
        }
        .build()
        return _playingCardsW500Rounded!!
    }

private var _playingCardsW500Rounded: ImageVector? = null
